import React, { useCallback, useEffect, useRef } from "react";
import { Control, RegisterOptions, useController } from "react-hook-form";
import "./AcedTextArea.scss";

type BaseInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "name" | "value" | "onChange" | "placeholder"
> & { label?: string; placeholder?: string };

// --- Mode-specific props ---
type RHFProps = {
  control: Control<any, any>;
  name: string;
  rules?: RegisterOptions;
  value?: never;
  onChange?: never;
};

type ControlledProps = {
  value: string;
  onChange: (value: string) => void;
  control?: never;
  name?: never;
  rules?: never;
};

type UncontrolledProps = {
  defaultValue?: string;
  control?: never;
  name?: never;
  value?: never;
  onChange?: never;
  rules?: never;
};

type AcedTextAreaProps = BaseInputProps &
  (RHFProps | ControlledProps | UncontrolledProps);

// export type AcedTextAreaProps = {
//   value?: string;
//   onChangeText?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
//   register?: UseFormRegisterReturn;
//   className?: string;
//   containerStyle?: string;
//   placeHolder?: string;
//   label?: string;
//   isDirty?: boolean;
//   errorMessage?: string;
// };

function isRHFProps(
  props: AcedTextAreaProps
): props is BaseInputProps & RHFProps {
  return "control" in props && "name" in props;
}

const AcedTextArea: React.FC<AcedTextAreaProps> = (props) => {
  if (isRHFProps(props)) return <AcedTextAreaRHF {...props} />;
  else return <></>;
  // } else if (isControlledProps(props)) {
  //   return <AcedInputControlled {...props} />;
  // } else {
  //   return <AcedInputUncontrolled {...props} />;
  // }
};

export default AcedTextArea;

const AcedTextAreaRHF: React.FC<BaseInputProps & RHFProps> = ({
  control,
  name,
  rules,
  label,
  placeholder,
  ...rest
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue: "",
  });
  const { error } = fieldState;

  const maxHeight = 700;
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = useCallback(
    (el: HTMLTextAreaElement) => {
      el.style.height = "auto"; // reset height
      const newHeight = el.scrollHeight;
      el.style.height = maxHeight
        ? `${Math.min(newHeight, maxHeight)}px`
        : `${newHeight}px`;
    },
    [maxHeight]
  );

  const setRefs = useCallback(
    (el: HTMLTextAreaElement | null) => {
      field.ref(el); // RHF's ref
      textareaRef.current = el;
      if (el) resize(el); // resize on mount
    },
    [field, resize]
  );

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    field.onChange(e);
    resize(e.target);
  };

  // Resize on external value change
  useEffect(() => {
    if (textareaRef.current) {
      resize(textareaRef.current);
    }
  }, [field.value, resize]);
  return (
    <div className="textarea-grand-container">
      {label && (
        <div className="label-container">
          <label className="select-label">{label}</label>
        </div>
      )}
      <div
        className={`textarea-container 
                `}
      >
        {/* ${containerStyle} */}
        <textarea {...field} ref={setRefs} className={"text-area"} />
        <label
          className={`placeholder-label ${
            field.value || rest.type === "date" ? "filled" : ""
          }`}
        >
          {placeholder}
        </label>
        {error && <p className="error-label">{error.message}</p>}
      </div>
    </div>
  );
};
